enum EnumTipoLiquidacao {
  BANCARIO = 1,
  ARQUIVO_RETORNO = 2,
}

export default EnumTipoLiquidacao;
